/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */

'use strict';

function isPromise(p) {
  return !!p && typeof p.then === 'function';
}

module.exports = isPromise;


//////////////////
// WEBPACK FOOTER
// ./node_modules/relay-runtime/lib/isPromise.js
// module id = 1039
// module chunks = 0